import utils from '../../utils/index';

export default {
    namespaced: true,

    state: {
        history: [],
        currentIndex: 0,
        isUndoRedo: false,
        isStopAddingToHistory: false,
    },

    getters: {
        canUndo(state) {
            return !!state.currentIndex;
        },

        canRedo(state) {
            return state.history.length - 1 > state.currentIndex;
        },
    },

    mutations: {
        // setState used in the undo/redo to set a state from the history
        setState(state, {name, value}) {
            state[name] = value;
        },

        setCurrentIndex(state, index) {
            state.currentIndex = index;
        },

        setHistory(state, history) {
            state.history = history;
        },

        pushToHistory(state, mold) {
            state.history.push(mold);
        },

        setIsUndoRedo(state, isUndoRedo) {
            state.isUndoRedo = isUndoRedo;
        },

        setIsStopAddingToHistory(state, status) {
            state.isStopAddingToHistory = status;
        },
        
    },

    actions: {
        applyStateFromIndex({state, commit, dispatch}, index) {
            commit('setIsUndoRedo', true);

            commit('setCurrentIndex', index);

            let newState = state.history[index];
            
            let stateToSet = utils.deepCopy(newState);

            dispatch('setStateFromUndoRedo', stateToSet);
        },

        undo({state, dispatch}) {
            let newIndex = state.currentIndex - 1;

            dispatch('applyStateFromIndex', newIndex);
        },

        redo({state, dispatch}) {
            let newIndex = state.currentIndex + 1;

            dispatch('applyStateFromIndex', newIndex);
        },

        notNecessaryChange(ctx, {newValue, oldValue}) {

            // string to compare
            const str = 'Hover'; // 'isLineHover', 'isAngleHover', 'isHemHover'

            // get position of the first changed char
            let index = [...newValue].findIndex((el, index) => el !== oldValue[index]);

            // shift to the keyWord end position
            index -= 2;

            let sub = newValue.substring(index - str.length, index);

            return str === sub;
        },

        stopAddingToHistory({commit}) {
            commit('setIsStopAddingToHistory', true);
        },

        recoverAddingToHistory({commit}) {
            commit('setIsStopAddingToHistory', false);
        },

        async addToHistory({state, getters, commit, dispatch}, {name, newValue, oldValue}) {

            // check if adding to history has been forcibly stopped for some reasons
            if (state.isStopAddingToHistory) return;

            // check if change was necessary
            // unnecessary changes are: the item's hovering
            const noNeedToAdd = await dispatch('notNecessaryChange', {newValue, oldValue});

            if (noNeedToAdd) return;

            if (state.isUndoRedo) {
                commit('setIsUndoRedo', false);

                return;
            }

            if (!getters.canUndo) {
                await dispatch('clearHistory');

                let mold = utils.deepCopy({ name, value: JSON.parse(oldValue) });
                commit('pushToHistory', mold);
            }

            if (getters.canRedo) {
                await dispatch('resetHistoryFromIndex', state.currentIndex + 1);
            }

            let mold = utils.deepCopy({ name, value: JSON.parse(newValue) });
            commit('pushToHistory', mold);

            let newUndoIndex = state.history.length - 1;
            commit('setCurrentIndex', newUndoIndex);
        },

        resetHistoryFromIndex({state, commit}, index = 0) {
            let newHistory = state.history.slice(0, index);
            
            commit('setHistory', newHistory);
        },

        clearHistory({commit, dispatch}) {
            commit('setCurrentIndex', 0);
            dispatch('resetHistoryFromIndex', 0);
        },

        setStateFromUndoRedo({rootGetters, commit, dispatch}, {name, value}) {
            // disable points changing if the trim editing is disabled
            if (rootGetters['editor/trimEditDisabled']) return;

            if (name === 'points') {
                dispatch('editor/setPoints', value, {root: true});

                return;
            }

            commit('setState', {name, value});
        },

    }
}